"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;
var _Permissions = require("./Permissions");
var _PermissionSet = require("./PermissionSet");
var _User;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This class represents the currently logged in User and their details. The enum object Role identifies the 
 * permissions of the user.
 * 
 */

// JSON stringify doesn't handle BigInt, so we do it here
BigInt.prototype.toJSON = function () {
  return this.toString();
};
var User = exports.User = /*#__PURE__*/function () {
  function User(userJson) {
    var _this = this;
    _classCallCheck(this, User);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "lastName", void 0);
    _defineProperty(this, "firstName", void 0);
    _defineProperty(this, "email", void 0);
    _defineProperty(this, "role", void 0);
    //one of the values of User.Role
    _defineProperty(this, "databases", []);
    //a list of authorized databases
    _defineProperty(this, "hasApiKey", false);
    _defineProperty(this, "lastLogin", null);
    //Date containing last login, or null for never/unknown
    _defineProperty(this, "status", null);
    //Status of the user (active, locked out, or null for unknown)
    _defineProperty(this, "notifyIndex", 0);
    _defineProperty(this, "preferredLocation", void 0);
    _defineProperty(this, "permissionBits", void 0);
    //BigInt
    _defineProperty(this, "profileUrl", void 0);
    _defineProperty(this, "name", function () {
      return _this.firstName + " " + _this.lastName;
    });
    _defineProperty(this, "nameReversed", function () {
      return _this.lastName + ", " + _this.firstName;
    });
    /**
     * The default database is the first one in their list
     * @returns {String} the user's default database
     */
    _defineProperty(this, "defaultDatabase", function () {
      return _this.databases[0];
    });
    _defineProperty(this, "hasAlertStatus", function () {
      return _this.status !== "ACTIVE" && _this.status !== "PROVISIONED";
    });
    _defineProperty(this, "isNew", function () {
      return _this.status === "PROVISIONED";
    });
    _defineProperty(this, "isAdministrator", function () {
      switch (_this.role) {
        case User.Role.SUPERADMIN:
        case User.Role.ADMIN:
          return true;
        default:
          return false;
      }
    });
    // Most roles can have different permissions than default, but these can't
    _defineProperty(this, "hasAdjustablePermissions", function () {
      switch (_this.role) {
        case User.Role.SUPERADMIN:
        case User.Role.OBSERVER:
        case User.Role.KIOSK:
          return false;
        default:
          return true;
      }
    });
    /**
     * Determines if the user is a superadmin, returning true if they have SUPERADMIN permissions
     */
    _defineProperty(this, "isSuperAdmin", function () {
      return _this.role === User.Role.SUPERADMIN;
    });
    _defineProperty(this, "hasAllDatabases", function () {
      return _this.role === User.Role.AGENT || _this.role === User.Role.SUPERADMIN;
    });
    _defineProperty(this, "isKiosk", function () {
      return _this.role === User.Role.KIOSK;
    });
    _defineProperty(this, "isObserver", function () {
      return _this.role === User.Role.OBSERVER;
    });
    _defineProperty(this, "isSiteEmployee", function () {
      switch (_this.role) {
        case User.Role.SUPERADMIN:
        case User.Role.AGENT:
        case User.Role.EMPLOYEE:
          return true;
        default:
          return false;
      }
    });
    _defineProperty(this, "roleString", function () {
      return User.Role.prettyString(_this.role);
    });
    _defineProperty(this, "roleDescription", function () {
      return User.Role.description(_this.role);
    });
    _defineProperty(this, "hasPermissionTo", function (operation) {
      if (!_this.permissionBits) return false;
      var mask = BigInt(1) << BigInt(operation);
      return (_this.permissionBits & mask) > BigInt(0);
    });
    /**
     * Returns an array of the Permission names for all the Permissions a user has
     */
    _defineProperty(this, "getPermissions", function () {
      return _PermissionSet.PermissionSet.getPermissionsArray(_this.permissionBits);
    });
    /**
     * Given a Permission, sets the permission bit as well as those from inherited permissions
     */
    _defineProperty(this, "setPermission", function (permissionName) {
      _this.permissionBits = _PermissionSet.PermissionSet.setPermission(_this.permissionBits, permissionName);
    });
    /**
     * Given a Permission, clears the permission bit, and also any that inherit the permission
     */
    _defineProperty(this, "clearPermission", function (permissionName) {
      _this.permissionBits = _PermissionSet.PermissionSet.clearPermission(_this.permissionBits, permissionName);
    });
    _defineProperty(this, "setDefaultPermissions", function () {
      _this.permissionBits = _PermissionSet.PermissionSet.defaultPermissionsForRole(_this.role);
    });
    _defineProperty(this, "stringify", function () {
      // to JSON, supporting BigInt
      return JSON.stringify(_this);
    });
    if (userJson) {
      this.id = userJson.id;
      this.lastName = userJson.lastName;
      this.firstName = userJson.firstName;
      this.email = userJson.email;
      this.notifyIndex = userJson.notifyIndex;
      this.preferredLocation = userJson.preferredLocation;
      this.permissionBits = userJson.permissionBits ? BigInt(userJson.permissionBits) : null; //convert from String to BigInt

      if (userJson.hasApiKey) {
        this.hasApiKey = userJson.hasApiKey;
      }
      if (userJson.groups) {
        this.databases = userJson.groups.filter(function (group) {
          return group !== "admin";
        }); // leave out the admin okta group
      } else this.databases = [];
      if (User.Role.isOneOf(userJson.type)) {
        this.role = userJson.type;
      } else {
        console.log("Invalid role for user: " + this.name);
        this.role = null;
      }
      if (userJson.lastLogin) this.lastLogin = new Date(userJson.lastLogin);
      if (userJson.status) this.status = userJson.status;
      this.profileUrl = userJson.profileUrl;
    }
  }
  return _createClass(User, null, [{
    key: "createNew",
    value: function createNew(role) {
      var user = new User(); //empty user
      user.role = role; //set the type  
      user.databases = []; //initialize empty
      user.setDefaultPermissions(); //initialize our permissions

      return user;
    }
  }]);
}();
_User = User;
_defineProperty(User, "Role", {
  SUPERADMIN: 'SUPERADMIN',
  AGENT: 'AGENT',
  EMPLOYEE: 'EMPLOYEE',
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  ATTENDANT: 'ATTENDANT',
  KIOSK: 'KIOSK',
  OBSERVER: 'OBSERVER',
  //Returns true if the type is one of the User.Roles, false otherwise
  isOneOf: function isOneOf(type) {
    switch (type) {
      case _User.Role.SUPERADMIN:
      case _User.Role.AGENT:
      case _User.Role.EMPLOYEE:
      case _User.Role.ADMIN:
      case _User.Role.MANAGER:
      case _User.Role.ATTENDANT:
      case _User.Role.KIOSK:
      case _User.Role.OBSERVER:
        return true;
      default:
        return false;
    }
  },
  roleBelow: function roleBelow(type) {
    switch (type) {
      case _User.Role.SUPERADMIN:
        return _User.Role.AGENT;
      case _User.Role.AGENT:
        return _User.Role.EMPLOYEE;
      case _User.Role.EMPLOYEE:
        return _User.Role.ADMIN;
      case _User.Role.ADMIN:
        return _User.Role.MANAGER;
      case _User.Role.MANAGER:
        return _User.Role.ATTENDANT;
      case _User.Role.ATTENDANT:
        return _User.Role.KIOSK;
      case _User.Role.KIOSK:
        return _User.Role.OBSERVER;
      default:
        return null;
    }
  },
  prettyString: function prettyString(type) {
    switch (type) {
      case _User.Role.SUPERADMIN:
        return "Site Principal";
      case _User.Role.AGENT:
        return "Site Agent";
      case _User.Role.EMPLOYEE:
        return "Site Employee";
      case _User.Role.ADMIN:
        return "Account Administrator";
      case _User.Role.MANAGER:
        return "Facility Manager";
      case _User.Role.ATTENDANT:
        return "Attendant";
      case _User.Role.KIOSK:
        return "Kiosk";
      case _User.Role.OBSERVER:
        return "Observer";
      default:
        return "Invalid";
    }
  },
  description: function description(type) {
    switch (type) {
      case _User.Role.SUPERADMIN:
        return "Full site administration privilege";
      case _User.Role.AGENT:
        return "Representative with access to all databases";
      case _User.Role.EMPLOYEE:
        return "Representative who can manage Memberships and Members";
      case _User.Role.ADMIN:
        return "Manage organization users and Manage databases";
      case _User.Role.MANAGER:
        return "Check in Members, add, edit, and delete Memberships and Members";
      case _User.Role.ATTENDANT:
        return "Check in Members and View Member information";
      case _User.Role.KIOSK:
        return "Front Desk Kiosk Operations";
      case _User.Role.OBSERVER:
        return "Read-only view of all information";
      default:
        return "Invalid";
    }
  }
});